import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

const NAV_ITEMS = [
  { key: 'nav.home', href: '#hero' },
  { key: 'nav.garage', href: '#garaj' },
  { key: 'nav.villa', href: '#villa' },
  { key: 'nav.winter', href: '#kis-bahcesi' },
  { key: 'nav.projects', href: '#projeler' },
  { key: 'nav.about', href: '#hakkimizda' },
  { key: 'nav.contact', href: '#iletisim' },
];

export default function Header() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 z-50 w-full transition-all duration-500 ${
        scrolled
          ? 'bg-foreground-950/95 backdrop-blur-md border-b border-primary-500/20 py-2'
          : 'bg-transparent py-4'
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6">
        <a
          href="#hero"
          aria-label="VILLAGARAGE"
          className="flex items-center"
        >
          <img
            src="https://storage.helloreaddy.io/project_files/23cbf37b-3b60-45d6-b458-2fbb3e9ec10a/38c06273-6207-48ae-a08c-ac1e41dc7367_compressed_logo.webp"
            alt="VILLAGARAGE Premium Garage Systems"
            className="h-12 w-auto md:h-14 object-contain"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.key}
              href={item.href}
              className="whitespace-nowrap text-sm font-medium text-background-100/90 transition-colors hover:text-primary-400"
            >
              {t(item.key)}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <LanguageSwitcher dark />
          <a
            href="#iletisim"
            className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-400"
          >
            {t('nav.cta')}
          </a>
        </div>

        <button
          type="button"
          onClick={() => setMobileOpen((v) => !v)}
          aria-label="Open menu"
          aria-expanded={mobileOpen}
          className="lg:hidden flex h-10 w-10 items-center justify-center rounded-md text-background-50 cursor-pointer"
        >
          <i
            className={`text-2xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            aria-hidden="true"
          ></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="lg:hidden border-t border-foreground-700/40 bg-foreground-950/98 backdrop-blur-md px-4 py-6">
          <nav className="flex flex-col gap-1">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.key}
                href={item.href}
                onClick={() => setMobileOpen(false)}
                className="rounded-md px-3 py-3 text-base font-medium text-background-100 transition-colors hover:bg-foreground-800 hover:text-primary-400"
              >
                {t(item.key)}
              </a>
            ))}
          </nav>
          <div className="mt-4 flex flex-col gap-3">
            <LanguageSwitcher dark />
            <a
              href="#iletisim"
              onClick={() => setMobileOpen(false)}
              className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-center text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-400"
            >
              {t('nav.cta')}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}